import { customAlphabet } from './../lib/nanoid/non-secure/index.js';

const uuid = customAlphabet('qazwsxedcrfvtgbyhnujmikol', 6);

export { uuid };
